import React, { useState } from "react"
import "./CurriculumImageUploadSection.css"
import CurriculumImageUploadModal from "./CurriculumImageUploadModal"
import { ImageWithFallback } from "./views/display"
import { WingsButton } from "@wingspans-ui"

/**
 * Renders a preview of an image and a button for editing it
 * @param {string} props.imageURL - URL of currently selected image
 * @param {Function} props.updateImageURL - Given a new image URL, updates the image URL
 * @param {string} props.imageClassName - Class name used to style the image preview's appearance
 * @param {string} props.imageType - "Name" used in instructions, for example "Add Banner Image" instead of "Add Image"
 * @returns {JSX.Element}
 */
const CurriculumImageUploadSection = ({imageURL, updateImageURL, imageClassName="", imageType="Image"}) => {
  const [modalOpen, setModalOpen] = useState(false)

  const bannerImagePlaceholder = (
    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="47" height="48" rx="3.5" stroke="currentColor"/>
      <path d="M0.5 39L10.2359 28.4527C11.4454 27.1425 13.5239 27.1702 14.6981 28.5121L23 38M15 48.5L37.3283 21.6149C38.4814 20.2265 40.5904 20.1631 41.8248 21.4798L47 27" stroke="currentColor"/>
      <circle cx="12.5" cy="14.5" r="5" stroke="currentColor"/>
    </svg>
  )

  return (
    <div className="curriculum-image-upload-section">
      {imageURL ? (
        <ImageWithFallback 
          className={`image-preview-container selected-image-preview ${imageClassName}`}
          src={imageURL}
          role="button"
          onClick={() => setModalOpen(true)}
        />
      ) : (
        <button 
          className="image-preview-container image-preview-placeholder"
          onClick={() => setModalOpen(true)}
        >
          {bannerImagePlaceholder}
        </button>
      )}
      <WingsButton variant="secondary" size="mini" onClick={() => setModalOpen(true)}>
        {`${imageURL ? "Edit" : "Add"} ${imageType}`}
      </WingsButton>
      <CurriculumImageUploadModal
        show={modalOpen}
        onClose={() => setModalOpen(false)}
        updateImageURL={(url) => updateImageURL(url)}
        title={`${imageURL ? "Edit" : "Add"} ${imageType}`}
        isNew={!imageURL}
      />
    </div>
  )
}

export default CurriculumImageUploadSection
